

















































































































import { Component, Prop, Vue } from "vue-property-decorator";
import LabSupervisiSvc from "@/services/LabSupervisiService";
import { appModule } from "@/store/modules/app";

@Component
export default class LabSeksiChecklist extends Vue {
  @Prop({ required: true }) seksiKey!: string;
  @Prop({ required: true }) seksiLabel!: string;
  @Prop({ required: true }) items!: any[];
  @Prop({ default: false }) readonly!: boolean;

  /** Sesi lama masih punya jawaban ya/tidak/na — tampilkan read-only. */
  get hasLegacyHasil(): boolean {
    return this.items.some(i => i.hasil !== null && i.hasil !== undefined && i.hasil !== "");
  }

  hasilLabel(hasil: string): string {
    if (hasil === "ya") return "Ya";
    if (hasil === "tidak") return "Tidak";
    return "NA";
  }

  hasilColor(hasil: string): string {
    if (hasil === "ya") return "green";
    if (hasil === "tidak") return "red";
    return "grey";
  }

  isOutOfRange(item: any) {
    if (item.tipe_jawaban !== "numeric_range" || item.nilai_numeric == null) return false;
    const min = item.nilai_target_min;
    const max = item.nilai_target_max;
    if (min != null && item.nilai_numeric < min) return true;
    if (max != null && item.nilai_numeric > max) return true;
    return false;
  }

  async onFileSelected(item: any, file: File | null) {
    if (!file) return;
    Vue.set(item, "_uploading", true);
    try {
      const resp = await LabSupervisiSvc.uploadFotoBukti(file);
      if (resp?.data?.status == "1") {
        if (!item.foto_bukti) Vue.set(item, "foto_bukti", []);
        item.foto_bukti.push(resp.data.data.path);
        appModule.NoticeDelay("Foto berhasil diupload");
        this.emitChange();
      }
    } catch {
      // handled by ErrorAlert
    }
    Vue.set(item, "_uploading", false);
  }

  removeFoto(item: any, index: number) {
    if (item.foto_bukti) {
      item.foto_bukti.splice(index, 1);
      this.emitChange();
    }
  }

  emitChange() {
    this.$emit("change", this.items);
  }
}
